
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq8sI_jG7vFjpOHPOm_45UttXSCTTi_45CLMPVOW8ivMfNLTQMeta } from "/codebuild/output/src1884812930/src/src/pages/faq.vue?macro=true";
import { default as menuEmuA9fX3Dpu7EBiJDQ4e7zoVhIBiEg8x7HoCJnMM_E8Meta } from "/codebuild/output/src1884812930/src/src/pages/menu.vue?macro=true";
import { default as index3oXNjwSotR5DZKH7AJ6eVWBy_LnFijiSEWkfGzIK9Z4Meta } from "/codebuild/output/src1884812930/src/src/pages/index.vue?macro=true";
import { default as contactz1UkdAgLhjR_453tewDfBgCEDf6BCmTCLCFm1AevoYZvUMeta } from "/codebuild/output/src1884812930/src/src/pages/contact.vue?macro=true";
import { default as tutorialYPFlReNtqQoRCdHb52ur34X6YQB7FKF0vXo2mkLUi9QMeta } from "/codebuild/output/src1884812930/src/src/pages/tutorial.vue?macro=true";
import { default as agreementpkNHXCi5leTAnh8LOZnGT0G5Ne9nDLveys6NXS39cHMMeta } from "/codebuild/output/src1884812930/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass65ZTxVcC_PwoLV_HEbHIXi73LHTMLnJBY0wcvO_9DnkMeta } from "/codebuild/output/src1884812930/src/src/pages/about-pass.vue?macro=true";
import { default as indexdNAvCiq4TxvqAfxbsKI4yDo4txtXbBxuQz9xieg8GTEMeta } from "/codebuild/output/src1884812930/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93BjAifxQQetW6HU3jzkePRgzl74Hx3cFaLnlThvZL48kMeta } from "/codebuild/output/src1884812930/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance5oqp5sneNI31_3uuyQxXFL9lrPM7UyP2fCgV0Ne3eMQMeta } from "/codebuild/output/src1884812930/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93kZIMeepL_45waRqjOpHOi0omn3jNCnAiLp3JLBk3b_45_FEMeta } from "/codebuild/output/src1884812930/src/src/pages/notice/[id].vue?macro=true";
import { default as indexc1OrlDoxiPMqgtzKrXbWGdyCfIH7lRHRhk5DXhwysL4Meta } from "/codebuild/output/src1884812930/src/src/pages/coupon/index.vue?macro=true";
import { default as indexhIBOijctMlsEkls9jKb3rkxp0zPObkOtKtkPshPa7fMMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/index.vue?macro=true";
import { default as indexCECCcFSxPFm9XSuy3bAVKnAfwg0SB3bNMvst90hJe3IMeta } from "/codebuild/output/src1884812930/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93NToEQdHI5jOhMAoscEopInKddwmX1zVO7OBhKJRmqOUMeta } from "/codebuild/output/src1884812930/src/src/pages/parking/[id].vue?macro=true";
import { default as indexTJ5qBV40XjX64PTjd3J_QwQJw2vxEmrqpVWJA_24I6EMeta } from "/codebuild/output/src1884812930/src/src/pages/history/index.vue?macro=true";
import { default as index0u01tOMTkG9fO50_45sLTfIwI_Qy0cPAMidrRnLVUCvnMMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/index.vue?macro=true";
import { default as index0nSyVl6I60383L_MP2ZkeJdCxWHfJLGVwyx_gw5aNLgMeta } from "/codebuild/output/src1884812930/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexE_b1OasDD7rPgwB2L7zepK0DSVl_53sAdYzsPzXnwI8Meta } from "/codebuild/output/src1884812930/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavizBtX7FpUdwODTcf4na5khngDaki3tEHkGuG7ctqSdo4Meta } from "/codebuild/output/src1884812930/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_VqzMWPRVoeKRAefe_rlVkfM33M2F6UBKGlZwoQIRL8Meta } from "/codebuild/output/src1884812930/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementBOdXub0GHtZ4Ov4jZMOOiGkAvb_zaRDZM7B_Ww3nODEMeta } from "/codebuild/output/src1884812930/src/src/pages/pass-agreement.vue?macro=true";
import { default as index5RNBO_45xAt5CYna4_45qFHkmg94ojOl9l6JlN2CQEHcqW8Meta } from "/codebuild/output/src1884812930/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dsPKwpvSqRgz9j5vaYp0f96vbqWqAPA74iEAH1j6hVbEMeta } from "/codebuild/output/src1884812930/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmyz_PU5ylfqebAvscgWIn65aYB2gVbgvSDbnqF9_45G8foMeta } from "/codebuild/output/src1884812930/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indext8jVKpPAmJNoB8J4SUhOg6gDigVSATm3qPBQ72sUAqwMeta } from "/codebuild/output/src1884812930/src/src/pages/card/create/index.vue?macro=true";
import { default as indexEgeIqVuJqkHV2f1cXcx_45cCJaBa_455g_gftgVwNXk6_BgMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirma8nkkDYZXhMdoiRyAImsvCaFh71aHhP2p_ufJhnUB8sMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmj3L5OS1WBDpXCmSXnZodAay0eIHUD3MPbJtmK56D8fUMeta } from "/codebuild/output/src1884812930/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeruD_2_45RLADTyx8VIeVW68x4gUfgbKb4OzDcGYWoD84AMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/complete.vue?macro=true";
import { default as registerzedS7q7W7HxaZ3MMlb0MzLHRsqfcUG0Z4oU2biPApaUMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_937EtfaKlXOnOvks00wF1wSc8657ROWgKM0emAVyy8eHoMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmhkLV_jkehm_45zFmTEehGl_45Y6t7KiH9wH6bX_45tBcdDSXgMeta } from "/codebuild/output/src1884812930/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Y0Nkk5hucUG2b0_45Tx4_45YI0DOe_45uSdFPH7zGx6O_45_B4EMeta } from "/codebuild/output/src1884812930/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexy_45ZznakLEz197I2Dr5JOdu_4568YD8n_45uXkDoadPjqI7UMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codexOO_45iJprTjVKj6U3UI4Kx8OY9fMLLxpbCD1IjPLHmBsMeta } from "/codebuild/output/src1884812930/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codernRgOYLrQqDKM_nAHgMjw4NbqajJjFYtXbS7aqvr3s4Meta } from "/codebuild/output/src1884812930/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeJFBSi_45VT2EtNzrCYczvyAKI0L_45O8CC88OSsF70eGO1QMeta } from "/codebuild/output/src1884812930/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerHWnxW_9TzcQzRLhqRjDt300SPedHleVOphkKainQQecMeta } from "/codebuild/output/src1884812930/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeDUWrkZ2w5cTkMb7j_HWwSeItUtSHiyqz7jWCCavo9GEMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexhSr69OKbinzAVXK4A_aCquiin7FaXAHUsdfCi_S6lJYMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmb7HiHzu85_45aH5BLCQcMqUTnRRA2U1w7qKKRLJRjYzGQMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete8CiA2h9sbPpXVIeR2oJqvD0m7ZdgC4jErTbN64ez_45CYMeta } from "/codebuild/output/src1884812930/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexkb25rPc1m3r1h8oqhSMHSqldZcaSki2l9Fxo06nIDAgMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ihe7IIYtLDUmzHG1L_45VRQ5h_45oRbLeRbzGqP85uFtY44Meta } from "/codebuild/output/src1884812930/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completekgtwuvQhzPYx3kEPEqxU_45Al3BKRlCcJ_9xAVabMHma4Meta } from "/codebuild/output/src1884812930/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasNJxnrKE3JWCkf8XGPrtfY3S156tLm0lhlJXEfNNi5z8Meta } from "/codebuild/output/src1884812930/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplestVWxRkaqwFJaLmJYE7q9w_JWbXSK8sTvWBEIFmpe6MMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email8CAePM_TarJ_e9_LqpLCKxDLumLliS516ZfAsqLqwuwMeta } from "/codebuild/output/src1884812930/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmzK5e216_H3V9INd3wcHDsj462slqbxM6nn9RehrS_isMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentLSad3WwB9gvMPMLma_HwOaCSAaGVtWvVfNlc0jVSsnIMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhbM7fo_45iSLqoThtqZlAnQq0_mqSa8Ez5vQ4WVyXH8FsMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateG_45noGzsGzhX_bWQ7zSknTRBLyPvu3bJItgGbDYGmTTMMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeVfhaS8UKUwvp0NuYs7Y74cEOnepMw_45g_45ZNIdgdtbD2MMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codemVNumdY22AnpIR_t9i55Z1qBNg_45ZD1_45YH9GFbzDDr9QMeta } from "/codebuild/output/src1884812930/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordwmePVlO5wZvYSKH_ZY6IMqwfEmcBXTUSV4iKnfxJypIMeta } from "/codebuild/output/src1884812930/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaslseCRBr40vRZvSPVvlB03a_PsEhQb7ljkWk1AdiKoAIMeta } from "/codebuild/output/src1884812930/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerOCl00CTs7XIWcGl2VlirMv2HVxOlAiUMd0o9ATeDuTcMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codea4LV0g4hBBJ21xeV_Lx8z_45qLwDL2jC_sOPeNABuTg_gMeta } from "/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexO72P7s1aplb_StrpzcaHsN6uYpdgpOm_R0QBHukjgW4Meta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexWoDAvXT2w1SKIHSRau7B959K8SgayNhP2AWWDgf1CcIMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexnBzX8EOx1K4YU0AXmviF9Vp6qh_pZVaohhVtI_r0i4EMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexyYWqUqD08oE3WNrIiP3zqGmAi2Om19NBnnuLPiBs2DcMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateXE1AYC_O_45RIODNVgW_45elbfnf60cETQDg_mvRieThsV8Meta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completelKbdKVa_453a_45_45d_45_45oqUqSTKfTdscryJVW8yd6Sn6_WZkMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmYpwjtxGfG5wmv1WpcJDjEFCbO5uYlktwYSGvBqTcYhIMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexoDRCR7PwzEdiI3K7TrqZmIGaVLNhHWA3SACWohDP798Meta } from "/codebuild/output/src1884812930/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete6NsUKLF00hGUiKQbZQXHvcjOnX90f_45FZgCusVKQLoCEMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update25KDz_45EVpP_45JmeH5z3BshGIAADmONR5pO7IQMwptrSAMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexGJWE2ieDlLxLACmMjczVzS_m2lnh7mGVbfmpfvtx0esMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexXYQaASXU_vJpLZVm74_45J0_459thVaPHqHHuz_45FgbM9BPsMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completewka_1SESUr8l_wmSr3nBdaUho6PJS17_45MMfzpDQ19SQMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexR4oL7ZU3RAgdDzfNevkCvTZIqvcudl0t4OP7ZTTHs9gMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeRT2PdkQgP8oa_45j52dSS8jhmt4Xo_LMUoZLmGmx884AoMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index3nuRC2FwdrHFQgNPSVyku2ytYZizvCbjOg7kB2kUONIMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexd7sQ0Xnj_45IYYImRAbEt4PSmQVvnvNOYEeK5jyYeMpXEMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index1NO3ByFiaQ6hDWmMmXPJtSRv29cP2RcbEaNZgp0JXNcMeta } from "/codebuild/output/src1884812930/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatejblqf8oh3zS7wW5_6uDMs_R90xqIdBhUpZc3UywQETIMeta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmGgya1HgMVkQ7pohC_45VNnPSHCS5p_ZJbtRresJ2c_45TR4Meta } from "/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuEmuA9fX3Dpu7EBiJDQ4e7zoVhIBiEg8x7HoCJnMM_E8Meta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index3oXNjwSotR5DZKH7AJ6eVWBy_LnFijiSEWkfGzIK9Z4Meta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexc1OrlDoxiPMqgtzKrXbWGdyCfIH7lRHRhk5DXhwysL4Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexTJ5qBV40XjX64PTjd3J_QwQJw2vxEmrqpVWJA_24I6EMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index0nSyVl6I60383L_MP2ZkeJdCxWHfJLGVwyx_gw5aNLgMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexE_b1OasDD7rPgwB2L7zepK0DSVl_53sAdYzsPzXnwI8Meta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indext8jVKpPAmJNoB8J4SUhOg6gDigVSATm3qPBQ72sUAqwMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirma8nkkDYZXhMdoiRyAImsvCaFh71aHhP2p_ufJhnUB8sMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmj3L5OS1WBDpXCmSXnZodAay0eIHUD3MPbJtmK56D8fUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeruD_2_45RLADTyx8VIeVW68x4gUfgbKb4OzDcGYWoD84AMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerzedS7q7W7HxaZ3MMlb0MzLHRsqfcUG0Z4oU2biPApaUMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmhkLV_jkehm_45zFmTEehGl_45Y6t7KiH9wH6bX_45tBcdDSXgMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codexOO_45iJprTjVKj6U3UI4Kx8OY9fMLLxpbCD1IjPLHmBsMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codernRgOYLrQqDKM_nAHgMjw4NbqajJjFYtXbS7aqvr3s4Meta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeJFBSi_45VT2EtNzrCYczvyAKI0L_45O8CC88OSsF70eGO1QMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerHWnxW_9TzcQzRLhqRjDt300SPedHleVOphkKainQQecMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmb7HiHzu85_45aH5BLCQcMqUTnRRA2U1w7qKKRLJRjYzGQMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete8CiA2h9sbPpXVIeR2oJqvD0m7ZdgC4jErTbN64ez_45CYMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexkb25rPc1m3r1h8oqhSMHSqldZcaSki2l9Fxo06nIDAgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completekgtwuvQhzPYx3kEPEqxU_45Al3BKRlCcJ_9xAVabMHma4Meta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplestVWxRkaqwFJaLmJYE7q9w_JWbXSK8sTvWBEIFmpe6MMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email8CAePM_TarJ_e9_LqpLCKxDLumLliS516ZfAsqLqwuwMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmzK5e216_H3V9INd3wcHDsj462slqbxM6nn9RehrS_isMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentLSad3WwB9gvMPMLma_HwOaCSAaGVtWvVfNlc0jVSsnIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhbM7fo_45iSLqoThtqZlAnQq0_mqSa8Ez5vQ4WVyXH8FsMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeVfhaS8UKUwvp0NuYs7Y74cEOnepMw_45g_45ZNIdgdtbD2MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codemVNumdY22AnpIR_t9i55Z1qBNg_45ZD1_45YH9GFbzDDr9QMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordwmePVlO5wZvYSKH_ZY6IMqwfEmcBXTUSV4iKnfxJypIMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerOCl00CTs7XIWcGl2VlirMv2HVxOlAiUMd0o9ATeDuTcMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codea4LV0g4hBBJ21xeV_Lx8z_45qLwDL2jC_sOPeNABuTg_gMeta || {},
    component: () => import("/codebuild/output/src1884812930/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1884812930/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]